import type { FunctionInterpolation, Interpolation } from "@emotion/react";

import type { TransitionShape } from "../Transition.emotion";

const makeMaskImageUrl = (
  shape: TransitionShape,
  duration: number,
  id: string,
) => {
  switch (shape) {
    case "circle":
      return `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none" stroke="none"><rect x="0" y="0" width="100%" height="100%" fill="black" mask="url(%23mask${id})" /><defs><mask id="mask${id}"><rect x="0" y="0" width="100%" height="100%" fill="white" /><circle fill="black" cx="5" cy="5"><animate attributeName="r" values="0;10" dur="${duration}ms" repeatCount="1" fill="freeze"></animate></circle></mask></defs></svg>')`;
    case "cross":
      return `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none" stroke="none"><rect x="0" y="0" width="100%" height="100%" fill="black" mask="url(%23mask${id})" /><defs><mask id="mask${id}"><rect x="0" y="0" width="100%" height="100%" fill="white" /><rect fill="black" y="0" height="100%"><animate attributeName="x" values="5;0" dur="${duration}ms" repeatCount="1" fill="freeze"></animate><animate attributeName="width" values="0;10" dur="${duration}ms" repeatCount="1" fill="freeze"></animate></rect><rect fill="black" x="0" width="100%"><animate attributeName="y" values="5;0" dur="${duration}ms" repeatCount="1" fill="freeze"></animate><animate attributeName="height" values="0;10" dur="${duration}ms" repeatCount="1" fill="freeze"></animate></rect></mask></defs></svg>')`;
    case "square":
      return `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none" stroke="none"><rect x="0" y="0" width="100%" height="100%" fill="black" mask="url(%23mask${id})" /><defs><mask id="mask${id}"><rect x="0" y="0" width="100%" height="100%" fill="white" /><rect fill="black"><animate attributeName="x" values="5;0" dur="${duration}ms" repeatCount="1" fill="freeze"></animate><animate attributeName="y" values="5;0" dur="${duration}ms" repeatCount="1" fill="freeze"></animate><animate attributeName="width" values="0;10" dur="${duration}ms" repeatCount="1" fill="freeze"></animate><animate attributeName="height" values="0;10" dur="${duration}ms" repeatCount="1" fill="freeze"></animate></rect></mask></defs></svg>')`;
    default:
      return "";
  }
};

export const shape: {
  exiting: Interpolation;
  exited: FunctionInterpolation<{
    shape: TransitionShape;
    duration: number;
    id: string;
  }>;
} = {
  exited: ({ shape, duration, id }) => ({
    maskImage: makeMaskImageUrl(shape, duration, id),
    maskSize: "cover",
    maskMode: "alpha",
    maskOrigin: "border-box",
    maskPosition: "center center",
    zIndex: 1,
  }),
  exiting: {
    zIndex: 1,
  },
};
